import axiosClient from './axiosClient';

const categoryApi = {
  get: () => {
    const url = '/categories';
    return axiosClient.get(url);
  },
  create: (data) => {
    const url = '/categories';
    return axiosClient.post(url, data);
  },
  edit: (id, data) => {
    const url = `/categories/${id}`;
    return axiosClient.put(url, data);
  },
  delete: (id) => {
    const url = `/categories/${id}`;
    return axiosClient.delete(url);
  },
};

export default categoryApi;
